import React, { useEffect, useMemo } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { decorationMobx, eatTypeStatusMobx, recommendMobx, queueOrderingMobx, preOrderingMobx } from '@mobxStore'
import { RESTAURANT_EVENT, cartMobx, productCenter, productMobx, restaurantCenter, restaurantConfig, storeMobx } from 'restaurant'
import { useHistoryNew, setDocumentTitle } from '@utils'
import CartBar from '../menu/components/CartBar'
import productStyleController from '@ctrls/productStyleController'
import { observer } from 'mobx-react'
import { MktController, CashierController } from '@ctrls/index'
import { MenuStyleDefault, MenuStyleWaterfall } from './components'
import { Header } from '@cps'
import './index.scss'
import EatTypeSwitcher from '../../pages/menu/components/EatTypeSwitcher'

const Recommend: React.FC = (props: any) => {
  const history = useHistoryNew()
  const { enableEatTypeList } = eatTypeStatusMobx
  const isBuyTogether = !!Config.buyTogetherId
  const { eatTypeEntries, eatTypeEntriesMap } = decorationMobx
  const eatType = cartMobx.info.eatType
  const showEatType = eatTypeEntries.length >= 2 && !isBuyTogether && !queueOrderingMobx.inPreQueueOrdering && !preOrderingMobx.checkPreOrder && restaurantConfig.displayMode !== 'waterfallCategory'

  const params: {
    title: string;
    uid: string;
    type: string;
  } = props.match?.params || {
    title: i18n.t('pageName.recommend'),
    uid: '',
    type: 'product',
  }

  /** 返回 */
  const handleBack = () => {
    if (history.getPrevState() !== '/menu') {
      history.replace('/menu')
    } else {
      MktController.goBack(history)
    }
  }

  /** 路由advertBrand 说明是小程序广告来的，需要重新获取门店，广告和餐品的数据 */
  const getAdvertInit = () => {
    const type = props.match?.params?.type
    const uid = props.match?.params?.uid
    if (type && uid) {
      recommendMobx.initPick(params)
      CashierController.initInPageForNoStore('recommend', 'push')
    }
  }

  /** 初始化商城商品 */
  const getProductInit = async () => {
    await recommendMobx.getMobileTemplateData(params.uid)
  }
  useEffect(() => {
    if (productMobx.isInited) {
      getProductInit()
    }
  }, [productMobx.isInited])

  useEffect(() => {
    if (storeMobx.info.storeId) {
      if (eatTypeEntries.length) {
        const eatType = eatTypeEntries?.[0].value || enableEatTypeList?.[0]
        if (!productMobx.isInited && eatType) {
          cartMobx.setEatType(eatType, { isSync: false })
          productCenter.initProduct(eatType, storeMobx.info.storeId)
        }
      }
    }
  }, [enableEatTypeList, storeMobx.info.storeId])

  useEffect(() => {
    getAdvertInit()
    setDocumentTitle(params.title || i18n.t('pageName.recommend'))
    const eventBus = restaurantCenter.on(RESTAURANT_EVENT.MENU_END, () => {
      getProductInit()
    })
    return () => {
      productStyleController.clearWaterfallData()
      restaurantCenter.off(eventBus)
    }
  }, [])

  const eatTypeEntriesValueArr = useMemo(() => {
    const arr: TEatType[] = eatTypeEntries.map(item => item.value)
    return arr
  }, [eatTypeEntries])

  return (
    <IonPage className='poster-wrap menu'>
      <Header title={params.title || i18n.t('pageName.recommend')} onBack={handleBack}>
        {!!showEatType && <EatTypeSwitcher types={eatTypeEntriesValueArr} value={eatType} onChange={(value) => CashierController.switchEatType(value)} />}
      </Header>
      <IonContent className='menu-container' style={{ backgroundColor: '#f4f4f4', '--background': '#f4f4f4' }}>
        <div className={`recommend-measure-height ${!decorationMobx.tabBarVisible ? ' no-tabbar' : ''}`} id='recommendWarp'>
          {restaurantConfig.displayMode === 'waterfallCategory' ? <MenuStyleWaterfall /> : <MenuStyleDefault />}
        </div>
      </IonContent>
      <CartBar onClick={() => history.replace('/checkout')} />
    </IonPage>
  )
}

export default observer(Recommend)
